import Joi from 'joi';

export const EmergencyAnswerSchema = Joi.object({
  emergencyId: Joi.number().required(),
  description: Joi.string().required(),
  answerDate: Joi.date().required(),
});

export const EmergencyAnswerAttachmentSchema = Joi.object({
  name: Joi.string().required(),
  file: Joi.string().required(),
});
